"use client"

import type React from "react"
import { useState } from "react"
import { Col, Container, Row } from "reactstrap"
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs"
import ExhibitionStatisticsList from "./ExhibitionStatisticsList"

const ExhibitionStatisticsContainer: React.FC = () => {
  const [refreshTrigger, setRefreshTrigger] = useState(false)

  const handleRefresh = () => {
    setRefreshTrigger((prev) => !prev)
  }

  return (
    <>
      <Breadcrumbs mainTitle="Exhibition Statistics" parent="Exhibitions" />
      <Container fluid>
        <Row>
          <Col md="12">
            <ExhibitionStatisticsList refreshTrigger={refreshTrigger} onRefresh={handleRefresh} />
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default ExhibitionStatisticsContainer
